import { mutator } from 'satcheljs';
import setSmimeErrorCode from '../actions/setSmimeErrorCode';

/**
 * Mutator that sets the S/MIME error code and context in smimeViewState
 * in case S/MIME encoding is failed.
 */
export default mutator(setSmimeErrorCode, actionMessage => {
    const { smimeViewState, errorCode, errorContext } = actionMessage;
    smimeViewState.errorCode = errorCode;
    smimeViewState.errorContext = errorContext;
});
